<template>
   <div v-if="locktitle" class="unlock-section">
        <div class="img">
          <img :src="lockimage"  alt="Logo" />
        </div>
        <div class="img-content">
          <h4>{{ locktitle }}</h4>
          <span> <b>Only {{ lockrate }}</b></span>
          <button @click="goToOfferLink(locklink)"  class="get-started">Explore Now</button>
        </div>
      </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
const props = defineProps({
  locktitle: String,
  lockimage: String,
  locklink: [String, Number],
  lockrate:String,
  // Prepr product_type of the offer. A Genetic Test is a digital upgrade and is sold by
  // AncestryDetails; the blood-test page would ask for a delivery address.
  locktype: String
});
const goToOfferLink = (locklink) => {
  if (props.locktype === 'Genetic Test') {
    router.push({ name: 'AncestryDetails', params: { slug: locklink } });
    return;
  }
  router.push({ name: 'bloodTestDetails', params: { product: locklink } });
};

</script>
